<template>
  <el-card v-loading="loading" shadow="hover">
    <div style="padding: 10px 20px">
      <div v-if="editModel">
        <el-form
          ref="form"
          :size="$xUISize"
          :model="editModel"
          :rules="editRules"
          @submit.native.prevent
          label-width="auto"
          label-position="top"
        >
          <el-form-item label="角色名称" prop="roleName">
            <el-input
              placeholder="请输入角色名称"
              v-model="editModel.roleName"
            ></el-input>
          </el-form-item>
          <el-form-item label="权限规则" prop="actionRules">
            <customer-role-rule-select v-model="editModel.actionRules" />
          </el-form-item>
          <el-form-item label="备注说明" prop="optRemark">
            <el-input
              type="textarea"
              v-model="editModel.optRemark"
              :rows="2"
              maxlength="256"
              placeholder="输入备注说明内容"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="editSubmit"
              @submit.native.prevent
              @click="submitClick"
            >
              保存
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-empty
        v-else-if="!loading"
        :description="errorMsg || '正在加载内容'"
        :image-size="100"
      >
        <el-button v-if="errorMsg" @click="fetchModel" size="small">
          重新加载
        </el-button>
      </el-empty>
    </div>
  </el-card>
</template>

<script>
import customerRoleRuleSelect from '../../../../components/business/customerRoleRuleSelect.vue';
const defaultModel = {};

export default {
  components: { customerRoleRuleSelect },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params,
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query,
      );
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      editSubmit: false,
      editModel: null,
      editRules: {
        roleName: [
          {
            required: true,
            message: '请输入角色名称',
            trigger: 'change',
          },
        ],
      },
    };
  },
  methods: {
    submitClick() {
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          this.editSubmit = true;
          const method = this.editModel.guid
            ? 'biz.customer.role.info.update'
            : 'biz.customer.role.info.create';
          this.requestApi(method, this.editModel, {
            showError: true
          }).then((resp) => {
            this.success('保存成功');
            this.$drawer.refreshDrawer();
            this.$drawer.backDrawer();
          }).finally(() => {
            this.editSubmit = false;
          });
        } else {
          this.showValidate(data);
        }
      });
    },
    handleModel() {
      // nothing
      if (this.pageParams.customerGuid) {
        this.editModel.customerGuid = this.pageParams.customerGuid;
      }
    },
    fetchModel() {
      const guid = this.pageParams.guid;
      if (!guid) {
        // 新增
        this.editModel = Object.assign({}, defaultModel);
        this.handleModel();
      } else {
        // 编辑
        this.errorMsg = null;
        this.loading = true;
        this.requestApi('biz.customer.role.info.detail', {
          guid: this.pageParams.guid,
        }).then((resp) => {
          this.editModel = resp.data;
          this.handleModel();
        }).catch((err) => {
          this.errorMsg = (err && err.msg) || (err && err.message) || '连接服务器失败，请检查网络';
        }).finally(() => {
          this.loading = false;
        });
      }
    },
  },
  mounted() {
    this.fetchModel();
  },
};
</script>